var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhone1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0112 9.41126L9.03362 10.6337C7.51877 9.74363 6.25645 8.48131 5.36642 6.96646L6.58882 5.98886C6.73211 5.87419 6.83338 5.71528 6.8768 5.53697C6.92022 5.35865 6.90335 5.17097 6.82882 5.00326L5.71442 2.49366C5.6345 2.31383 5.49331 2.16822 5.31602 2.0828C5.13873 1.99737 4.93686 1.97769 4.74642 2.02726L2.62482 2.57686C2.42693 2.62875 2.2549 2.75133 2.14125 2.92143C2.0276 3.09154 1.9802 3.29738 2.00802 3.50006C2.38025 6.15105 3.60544 8.60879 5.49836 10.5017C7.39129 12.3946 9.84902 13.6198 12.5 13.9921C12.7026 14.02 12.9084 13.9727 13.0785 13.859C13.2485 13.7453 13.3709 13.5732 13.4224 13.3753L13.9728 11.2545C14.0224 11.064 14.0027 10.8621 13.9173 10.6849C13.8319 10.5076 13.6863 10.3664 13.5064 10.2865L10.9968 9.17206C10.8291 9.09772 10.6416 9.08086 10.4634 9.12412C10.2851 9.16738 10.1262 9.26833 10.0112 9.41126Z",
    stroke: "#323743",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone1);
export default __webpack_public_path__ + "static/media/phone-1.5d7d0ca907b4d53483e1c9bf40981ca6.svg";
export { ForwardRef as ReactComponent };